export default "__VITE_ASSET__DavlL8K$__"